import { render } from "./NavBarFooter.vue?vue&type=template&id=55fb584a"
import script from "./NavBarFooter.vue?vue&type=script&lang=js"
export * from "./NavBarFooter.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_f9a89c39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__